import { Pipe, PipeTransform } from '@angular/core'
import { ChatMessage } from './ngrx-store/app.state'
import { chatTimeline, ChatTimelineItem } from './utils/chat-timeline.util'

/**
 * A chat's messages with their day separators and sender groups (see chatTimeline). Pure: worked
 * out again only when the list changes - the store hands over a new array for every change.
 */
@Pipe({
  name: 'chatTimeline',
})
export class ChatTimelinePipe implements PipeTransform {
  transform(messages: ChatMessage[] | null | undefined): ChatTimelineItem[] {
    return chatTimeline(messages)
  }
}
